// Adds a link to the catalogue under "Sign up" on /login, and under "Have an account?
// Login" on /login#signup.
//
// The login page is Frappe's own (frappe/www/login.html) and is not shadowed by this app,
// so the link is placed from here instead of copying that template. Its label is NOT
// translated client-side: /login carries no message dictionary (frappe._messages is left
// empty by provide.js, and no core template fills it), so __() there would always return
// English. The server translates the label and hands it over in a global written into
// body_include (website_overrides.set_login_eshop_link), and this module only places it.
// body_include, not head_include: login.html overrides the head_include block for its own
// stylesheet and never renders the variable, so anything put there is dropped on this page.
//
// Nothing here reads or writes redirect-to: the link is a plain /products href, so a
// visitor who follows it simply leaves the login page.

const LOGIN_PATH = "/login"
// Marks a container this script has already filled, so running twice adds one link.
const PLACED_FLAG = "ioiEshopLink"

function on_login_page() {
	return window.location.pathname.startsWith(LOGIN_PATH)
}

function add_eshop_link() {
	if (!on_login_page()) {
		return
	}

	const link = window.ioi_partners_login_eshop_link
	if (!link || !link.label || !link.href) {
		// No label from the server: better no link than an untranslated one.
		return
	}

	// The blocks that carry a real view switch: "Sign up" under the login form (frappe's
	// login.html, a div) and "Have an account? Login" under the signup form (this app's
	// templates/signup.html, a <p> inside the card). Scoped to section.for-signup so the
	// "Back to Login" lines of the forgot / email-link views are not matched, and the
	// anchor check skips the signup-disabled notice, which is also a .sign-up-message.
	const containers = document.querySelectorAll(
		"div.sign-up-message, section.for-signup p.sign-up-message"
	)
	for (const container of containers) {
		if (container.dataset[PLACED_FLAG] || !container.querySelector('a[href="#signup"], a[href="#login"]')) {
			continue
		}
		container.dataset[PLACED_FLAG] = "1"

		// A second line rather than a third item on the first one: "Don't have an account?
		// Sign up" is one sentence, and the catalogue is a different offer. A plain anchor,
		// like "Sign up" next to it - the page already has one filled button (Login), and a
		// second would compete with it.
		container.appendChild(document.createElement("br"))
		const anchor = document.createElement("a")
		anchor.href = link.href
		anchor.textContent = link.label
		container.appendChild(anchor)
	}
}

frappe.ready(add_eshop_link)
